import { render } from "./ResourceFormSelect.vue?vue&type=template&id=09ff6963&ts=true"
import script from "./ResourceFormSelect.vue?vue&type=script&lang=ts"
export * from "./ResourceFormSelect.vue?vue&type=script&lang=ts"

import "./ResourceFormSelect.vue?vue&type=style&index=0&id=09ff6963&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__